import { PartialTranslation } from '../translations';

export const sk: PartialTranslation = {
  newChat: 'Nový chat',
  search: 'Hľadať',
  user: 'Používateľ',
  settings: 'Nastavenia',
  language: 'Jazyk',
  getHelp: 'Získať pomoc',
  viewAllPlans: 'Zobraziť všetky plány',
  learnMore: 'Dozvedieť sa viac',
  logOut: 'Odhlásiť sa',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Automatická detekcia',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Spýtajte sa na čokoľvek',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Osobné',
  freePlan: 'Bezplatný plán',
  current: 'Nuna',
  close: 'Fermi',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Zdroje',
  addResource: 'Pridať zdroj',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Napísať správu...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Pridať prílohu',
  sendMessage: 'Odoslať správu',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Prihlásiť sa',
  register: 'Zaregistrovať sa',
  welcomeBack: 'Vitajte v LawHelper',
  loginSubtitle: 'Váš AI asistent pre právny výskum',
  continueWithGoogle: 'Pokračovať s Google',
  continueWithMicrosoft: 'Pokračovať s Microsoft',
  continueWithWeChat: 'Pokračovať s WeChat',
  orContinueWith: 'alebo pokračovať s',
  emailTab: 'E-mail',
  phoneTab: 'Telefón',
  emailPlaceholder: 'Zadajte svoj e-mail',
  phonePlaceholder: 'Zadajte telefónne číslo',
  codePlaceholder: 'Zadajte 6-miestny kód',
  sending: 'Odosielanie...',
  verifying: 'Overovanie...',
  verify: 'Overiť',
  sendMagicLink: 'Odoslať magický odkaz',
  getVerificationCode: 'Získať kód',
  resendCode: 'Znovu odoslať kód',
  resendIn: 'Znovu odoslať za',
  magicLinkSent: 'Magický odkaz bol odoslaný na váš e-mail',
  magicLinkHint: 'Pošleme vám bezpečný odkaz na váš e-mail',
  otpSent: 'Overovací kód bol odoslaný',
  agreeToTerms: 'Pokračovaním súhlasíte s našimi',
  privacyPolicy: 'Zásady ochrany osobných údajov',
  termsOfService: 'Podmienky služby',
  and: 'a',
  privacyTitle: 'Vaše súkromie je dôležité',
  privacyIntro: 'Používame cookies a podobné technológie na poskytnutie najlepšieho zážitku.',
  essentialCookies: 'Nevyhnutné cookies',
  essentialDesc: 'Potrebné na fungovanie stránky',
  analyticsCookies: 'Analytické cookies',
  analyticsDesc: 'Pomáhajú nám zlepšovať službu',
  marketingCookies: 'Marketingové cookies',
  marketingDesc: 'Používané na personalizovaný obsah',
  acceptAll: 'Prijať všetko',
  essentialOnly: 'Len nevyhnutné',
  customize: 'Prispôsobiť',
  savePreferences: 'Uložiť nastavenia',
  back: 'Späť',
  readPrivacyPolicy: 'Prečítajte si naše zásady ochrany osobných údajov',
  cookiePolicy: 'Zásady používania cookies',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI kontrola',
  aiDraft: 'AI návrh',
  smartAssistant: 'Šablóna',

  // 知识库搜索
  enableKnowledgeSearch: 'Povoliť vyhľadávanie',
  knowledgeSearchDesc: 'AI hľadá vo vašich dokumentoch',
  clickToDisable: 'Zakázať',
  clickToEnable: 'Povoliť',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zavrieť panel zdrojov',
  uploading: 'Nahrávanie %{fileName}...',
  processing: 'Spracovanie %{fileName}...',
  uploadSuccess: '✓ %{fileName} nahrané',
  uploadError: '✗ Nahrávanie zlyhalo: %{error}',
  quickAnswer: 'Rýchla odpoveď',
  quickAnswerDesc: 'Rýchla odpoveď na jednoduché otázky',
  cancelRequest: 'Zrušiť',
  library: 'Knižnica',
  filterAll: 'Všetko',
  filterChat: 'Chaty',
  filterReview: 'Kontrola',
  filterDraft: 'Koncept',
  filterTemplate: 'Šablóna',
  filterForm: 'Formulár',
  thinking: 'Premýšľam...',
  thinkingProcess: 'Myšlienkový proces',
  analyzingLegalLogic: 'Analyzujem právnu logiku...',
  lawhelperThinking: 'Lawhelper premýšľa...',
  serviceError: 'Chyba služby',
  uploaded: 'Nahrané',
  settingsGeneral: 'Všeobecné',
  settingsNotifications: 'Oznámenia',
  settingsAppearance: 'Vzhľad',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Oznámenia o odpovediach',
  settingsResponseNotificationsDesc: 'Oznámenie pri dokončení odpovede AI',
  settingsColorMode: 'Farebný režim',
  settingsLight: 'Svetlý',
  settingsDark: 'Tmavý',
  settingsSystem: 'Systém',
  about: 'O aplikácii',
  reviewTitle: 'Kontrola dokumentu',
  exitReview: 'Ukončiť kontrolu',
  uploadPrompt: 'Nahrajte PDF na kontrolu',
  uploadButton: 'Vybrať súbor',
  startChatConfig: 'Napíšte "Skontrolovať dokument"',
  reviewPlaceholder: 'Napíšte správu...',
  analyzing: 'Kontrolujem...',
  reviewComplete: 'Kontrola dokončená',
  issuesFound: 'Nájdených %{count} problémov',
  draftTitle: 'Tvorba právneho dokumentu',
  draftPlaceholder: 'Upravujte tu alebo nechajte AI generovať...',
  analyzingTemplate: 'Analýza šablóny %{name}...',
  templateAnalyzed: '✅ Šablóna %{name} analyzovaná!',
  templateAnalysisPrompt: 'Analyzovať kľúčové klauzuly',
  parsingFailed: '⚠️ Súbor sa nepodarilo analyzovať.',
  generating: 'Generujem...',
  generatedSuccess: '✅ Dokument vygenerovaný!',
  drafterWelcome: 'Vitajte v AI asistentovi dokumentov',
  drafterYouCan: 'Môžete:',
  drafterUploadTemplate: 'Nahrať šablónu na AI analýzu',
  drafterDescribeNeeds: 'Opísať požiadavky dokumentu',
  drafterLetAiHelp: 'AI pomôže so zmluvami, dohodami atď.',
  drafterExamples: 'Príklady:',
  drafterExampleRental: '"Vytvorte nájomnú zmluvu"',
  drafterExampleLabor: '"Vyplňte pracovnú zmluvu"',
  drafterInputPlaceholder: 'Opíšte svoje potreby...',
  drafterThinking: 'Premýšľam...',
  drafterHistoryTitle: 'História',
  drafterNoHistory: 'Žiadna história',
  drafterNewChat: 'Nový chat',
  drafterHistory: 'História',
  drafterRemoveAttachment: 'Odstrániť prílohu',
  drafterLineHeight: 'Výška riadku',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export do Word (.docx)',
  drafterExportPdf: 'Export do PDF',
  drafterSave: 'Uložiť dokument',
  drafterDownload: 'Stiahnuť dokument',
  drafterUndo: 'Späť',
  drafterRedo: 'Znovu',
  drafterBold: 'Tučné',
  drafterItalic: 'Kurzíva',
  drafterStrike: 'Prečiarknuté',
  drafterUnderline: 'Podčiarknuté',
  drafterHighlight: 'Zvýraznenie',
  drafterLink: 'Vložiť odkaz',
  drafterAlignLeft: 'Vľavo',
  drafterAlignCenter: 'Na stred',
  drafterAlignRight: 'Vpravo',
  drafterAlignJustify: 'Do bloku',
  drafterList: 'Zoznam',
  drafterBulletList: 'Odrážkový zoznam',
  drafterOrderedList: 'Číslovaný zoznam',
  drafterTaskList: 'Zoznam úloh',
  drafterOpenResource: 'Otvoriť panel zdrojov',
  drafterStopGeneration: 'Zastaviť generovanie',
  drafterAgentMode: 'Režim agenta aktívny',
  drafterAgentModeOn: 'Režim agenta aktívny',
  drafterAgentModeOff: 'Normálny režim',
  drafterUploadAttachment: 'Nahrať prílohu',
  drafterExit: 'Ukončiť',
  drafterConfirm: 'Potvrdiť',
  drafterOpenLink: 'Otvoriť odkaz',
  drafterDeleteLink: 'Zmazať odkaz',
  drafterQuote: 'Citácia',
  workflowTitle: 'AI proces',
  workflowRunning: 'Prebieha...',
  workflowReady: 'Pripravený',
  workflowCompleted: 'Dokončený',
  workflowStartFailed: 'Spustenie procesu zlyhalo',
  workflowExecutionFailed: 'Vykonanie procesu zlyhalo',
  workflowInterrupted: 'Proces prerušený',
  workflowProcessing: 'Spracovávam...',
  workflowStepsCompleted: 'krokov dokončených',
  workflowStepsTotal: 'Proces dokončený (%{count} krokov)',
  acceptChanges: 'Prijať zmeny',
  rejectChanges: 'Odmietnuť zmeny',
  changesAccepted: 'Zmeny prijaté',
  changesRejected: 'Zmeny odmietnuté',
  stopWorkflow: 'Zastaviť',
  restartWorkflow: 'Reštartovať',
  startDrafting: 'Začať tvoriť',
  interrupt: 'Zastaviť',
  documentSubject: 'Predmet dokumentu *',
  documentType: 'Typ dokumentu',
  jurisdiction: 'Jurisdikcia',
  specialRequirements: 'Špeciálne požiadavky (voliteľné)',
  clickStartDrafting: 'Kliknite "Začať tvoriť"',
  docTypeContract: 'Zmluva',
  docTypeAgreement: 'Dohoda',
  docTypeNotice: 'Oznámenie',
  docTypeLetter: 'List',
  docTypePetition: 'Petícia',
  docTypeWill: 'Závet',
  docTypePowerOfAttorney: 'Splnomocnenie',
  countryChina: 'Čína',
  countryUSA: 'USA',
  countryGermany: 'Nemecko',
  countryJapan: 'Japonsko',
  countryFrance: 'Francúzsko',
  countryUK: 'Veľká Británia',
  citationVerified: 'Overené',
  citationUnverified: 'Neoverené',
  imageLoadFailed: 'Obrázok sa nepodarilo načítať',
  smartDocTitle: 'Inteligentný asistent dokumentov',
  smartDocChatTitle: 'AI asistent dokumentov',
  smartDocDropPrompt: 'Presuňte PDF sem',
  smartDocSelectFile: 'Vybrať súbor',
  smartDocOr: 'alebo',
  smartDocWelcomeTitle: 'Vitajte v AI asistentovi',
  smartDocWelcomeYouCan: 'Môžete:',
  smartDocUploadForAI: 'Nahrať šablónu',
  smartDocDescribeDoc: 'Opísať požiadavky',
  smartDocLetAIDraft: 'AI pomôže so zmluvami',
  smartDocExamples: 'Príklady:',
  smartDocExampleRental: '"Vytvorte nájomnú zmluvu"',
  smartDocExampleLabor: '"Vyplňte pracovnú zmluvu"',
  smartDocInputPlaceholder: 'Opíšte potreby...',
  smartDocRemoveAttachment: 'Odstrániť prílohu',
  smartDocOpenResources: 'Otvoriť zdroje',
  smartDocExit: 'Ukončiť',
  reviewStartFailed: 'Spustenie kontroly zlyhalo',
  reviewFailed: 'Kontrola zlyhala',
  reviewFoundIssues: 'Kontrola dokončená, %{count} problémov.',
  cannotReadStream: 'Nedá sa čítať dátový prúd',
  parseEventFailed: 'Nedá sa analyzovať udalosť',
  errorPrefix: 'Chyba',
  unknownError: 'Neznáma chyba',
  file: 'Súbor',
  loading: 'Načítanie...',
  localFolders: 'Miestne priečinky',
  selectLocalFolder: 'Vybrať miestny priečinok',
  reselectFolder: 'Zmeniť priečinok',
  addToContext: 'Pridať do chatu',
  saveFile: 'Uložiť',
  renameFile: 'Premenovať',
  fileSaved: 'Súbor uložený',
  fileRenamed: 'Súbor premenovaný na %{name}',
  browserNotSupported: 'Váš prehliadač nepodporuje prístup k priečinkom',
  noFolderSelected: 'Vyberte priečinok',
  scanningFolder: 'Skenovanie priečinka...',
  selectFileToPreview: 'Vyberte súbor na náhľad',
  aiAnalyze: 'AI analýza',
};
